import { onRowEnter, onRowLeave } from '@bringg-frontend/monitoring-shared';

export default class TimelineRowEmitter {
	row: number | string = null;

	emitOver = (row: number | string | null) => {
		if (row === null) {
			onRowLeave(this.row);
			this.row = null;
		} else if (row !== this.row) {
			onRowLeave(this.row);
			onRowEnter(row);
			this.row = row;
		}
	};
}
